import httpRequest from "@/api";
import { BaseService } from "@/api/baseService";
import type { TruckTrackForm } from "../../../../common/types/track";
import type {
    QueryLicenseResponse,
    RouterPathResponse,
    VehicleHistoryVo,
    VehicleInfoResponse,
    VehicleVo
} from "@zhihaoscm/entity";
import type { VehicleHistoryForm } from "../../../../common/types/vehicle";

// 车辆服务
export class VehicleService extends BaseService<QueryLicenseResponse, VehicleVo, any, any> {
    // 获取司机信息
    public async getLicenseInfo(vclN: string, options: { silentError?: boolean } = {}) {
        const { data } = await this.service.get(`${this.path}/getLicenseInfo?vclN=${vclN}`, {
            silentError: options.silentError
        } as any);
        return data as QueryLicenseResponse[];
    }

    // 获取道路运输信息
    public async getRouterPath(form: TruckTrackForm) {
        const { data } = await this.service.get(`${this.path}/getRouterPath`, { params: form });
        return data as RouterPathResponse;
    }

    // 获取司机实时位置
    public async getTransTimeManage(vnos: string) {
        const { data } = await this.service.get(`${this.path}/getTransTimeManage?vnos=${vnos}`);
        return data as VehicleInfoResponse;
    }

    public async getHistoryList(): Promise<VehicleHistoryVo[]> {
        const { data } = await this.service.get(`/custom/vehicle/service/history`);
        return data;
    }

    public async clearHistory(): Promise<void> {
        const { data } = await this.service.delete(`/custom/vehicle/service/all-history`);
        return data;
    }
    public async deleteHistory(params: VehicleHistoryForm): Promise<void> {
        const { data } = await this.service.delete(`/custom/vehicle/service/history`, { data: params });
        return data;
    }

    public async addHistory(form: VehicleHistoryForm): Promise<void> {
        const { data } = await this.service.post(`/custom/vehicle/service/history`, form);
        return data;
    }
}

export const vehicleService = new VehicleService("/custom/vehicle/service", httpRequest);
